import styled from "@emotion/styled";
import { ComputationStatus } from "../../generated/gpb/api/route";

/**
 * A styled header container for the trip card.
 */
export const HeaderContainer = styled( "div" )( {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "4px",
    position: "relative",
} );

/**
 * A styled status icon container.
 */
export const StatusIconContainer = styled( "div" )<{ status: ComputationStatus | undefined, size: number }>( ( { status, size } ) => ( {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: `${size}px`,
    height: `${size}px`,
    borderRadius: "50%",
    color: "white",
    marginRight: "8px",
    backgroundColor: ( () =>
    {
        switch ( status )
        {
            case ComputationStatus.DONE:
                return "green";
            case ComputationStatus.ERROR:
                return "red";
            case ComputationStatus.IN_PROGRESS:
            case ComputationStatus.WAITING:
                return "blue";
            default:
                return "grey";
        }
    } )(),
} ) );

/**
 * A styled placeholder image container.
 */
export const PlaceholderImage = styled.div( {
    width: "100%",
    height: "150px",
    backgroundColor: "#e0e0e0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "16px",
} );
